import React, { Component } from "react";
import {Collapse} from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import { green,red } from '@mui/material/colors';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import AlertDialog from './AlertDialog'
import { withStyles } from '@mui/styles';
import {APIUploadData} from './Api'
import  pdf_config from './configs/pdf_configs.js';


var gerrors = []

const console_log = (text) => { 
    return  // Comment out if yoy want logging
    console.log(text)
}

const ColorButton = withStyles((theme) => ({
  root: {
    color: '#ffffff', // theme.palette.getContrastText(lightGreen[50]),
    backgroundColor: '#ff3099',
    '&:hover': {
      backgroundColor: '#ff3099',
    },
  },
}))(Button);

function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" {...props} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

class PictureUploads extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filelist: [],
            errors: [],
            uploading: false,
            description: '',
            show_alert: false,
            alert_text: '',
            alert_severity: 'info',
            delete_file: false,
            delete_file_msg: '',
            delete_file_index: -1,
            progress: 0,
            show_progress: false,
            upload_error: '',
            filelist: props.filelist
        }
    }

    sleep = async (x) => {
        return new Promise( resolve => setTimeout(resolve, x));
    }

    checkMimeType=(event)=>{
        //getting file object
        let files = event.target.files 
        //define message container
        // list allow mime type
       const types = ['image/png', 'image/jpeg', 'image/gif', 'image/tiff', 'image/bmp']
        var errors = gerrors
       // loop access array
        for(var x = 0; x<files.length; x++) {
         // compare file type find doesn't matach
             if (types.every(type => files[x].type !== type)) {
             // create error message and assign to container   
             var msg = files[x].name +  ' is an invalid Picture format - Only Picture Files (.png, .gif, .tif, .bmp) are supported';
             errors.push(msg)
           }
         };
         for(var z = 0; z<errors.length; z++) {// if message not same old that mean has error 
             // discard selected file
            //toast.error(err[z])
            event.target.value = null
        }
        gerrors = errors
        if(errors.length > 0)
            return false
        return true;
      }

      maxSelectFile=(event)=>{
        let files = event.target.files
        if (files.length > 20) { 
            const msg = 'Only 20 images can be uploaded'
            event.target.value = null
            //toast.warn(msg)
            var errors = gerrors
            errors.push(msg)
            gerrors = errors
            return false;
        }
        return true;
     }

     checkDuplicateFiles = (event) => {
        const file = event.target.files[0].name
        const files = this.state.filelist
        const description = this.state.description
        var errors = gerrors
        for(var i=0; i<files.length; i++) {
            if(files[i].filename.toLowerCase() === file.toLowerCase()) {
               var msg = "Duplicate File " + file + " found"
               errors.push(msg)
               this.setState({show_alert: true, alert_severity: 'error'})
               gerrors = errors
               return false
            }else if( description > '' && files[i].description.toLowerCase() === description.toLowerCase() ) {
                var msg = "Duplicate File " + file + " found"
                errors.push(msg)
                this.setState({show_alert: true, alert_severity: 'error'})
                gerrors = errors
                return false 
            }
        }
        gerrors = errors
        return true
    }

    checkFileSize=(event)=>{
        let files = event.target.files
        let size = 5000000 
        var errors = gerrors
        for(var x = 0; x<files.length; x++) {
            //(files[x].size + " , " + size)
            if (files[x].size > size) {
                var msg = files[x].name + ' is too large, please pick a smaller file. Maximum size is 5Mb'
                errors.push(msg)
                console_log(errors)
            }
        
        };
        for(var z = 0; z<errors.length; z++) {// if message not same old that mean has error 
            // discard selected file
            // toast.error(err[z])
            event.target.value = null
        }
        gerrors = errors
        if(errors.length > 0)
            return false
        return true;
    }
    onChangeHandler= async (event) =>{
        gerrors = []
        this.setState({show_alert: false})
        var file = event.target.files
        const desc = this.state.description

        if( this.checkFileSize(event) && 
            this.maxSelectFile(event) && 
            this.checkMimeType(event) &&
            this.checkDuplicateFiles(event) 
            ){ 
          // if return true allow to setState
          var {filelist} = this.state
          
          for(var i=0; i<file.length; i++) {
            if(file.length == 1)
                file[i].description = desc
            else
                file[i].description = ''
            file[i].filename = file[i].name
            file[i].filetype = file[i].type
            filelist.push(file[i] )

        }
          gerrors = []
          this.setState({filelist,loaded:0, description: ''})
          event.target.value = null
          this.props.onChange(this.state.filelist)
        //return true
        }else {
            event.target.value = null
            var error = ''
            gerrors.map(item => { error += item + ", "})
            console_log('after mapping errors ' + error)
            gerrors = []
            this.setState({show_alert: true, alert_severity: 'error',alert_text: error})
            event.target.value = null
            //return false
        }
    }
    onClickHandler = async () => {
        this.setState({uploading: false, show_progress: true, upload_error: ''})
        console_log("Start File Upload")
        const ret = await APIUploadData (this.props.flg_id,this.state.filelist, this.updateProgress, this.FileUpLoadComplete)
        console_log("File Upload Completed")
        console_log(ret)
        
    }

    FileUpLoadComplete = (ret) => {
        if(ret.status)
            this.setState({uploading: true, show_progress: false})
        else 
            this.setState({show_progress: false, uploading: false, upload_error: ret.error})
    }

    updateProgress = (event) => { this.setState({progress: event}) }

    updateDescription = (event) => {
        this.setState({description: event.target.value})
        this.props.onChange(this.state.filelist)
    }

    updateDesc = (event, index) => {
        var filelist = this.state.filelist
        filelist[index].description = event.target.value
        this.setState({filelist})
        this.props.onChange(this.state.filelist)
    } 

    DeleteFileFromList = (index) => {
        const file = this.state.filelist[index]
        const msg = "Are you sure you wish to Remove File ( " + 
            file.name + ") with Description of " + 
            file.description + ' from the list?'

        this.setState({delete_file: true, delete_file_msg: msg, delete_file_index: index})
        this.props.onChange(this.state.filelist)
    }
    delOnClose = (event) => {
        //console_log(event)
        if(event) 
        {
            var filelist = this.state.filelist
            var findex = this.state.delete_file_index
            var deletelist = filelist.filter((item,index) => { return (index !== findex)  })
            this.setState({delete_file: false, filelist: deletelist})
            this.props.onChange(deletelist)
        }else   
            this.setState({delete_file: false})
    }
    DeleteFileList = () => {
        this.setState({filelist:[]}) 
    }
    PreViewImage = (index) => {
        let preview = this.state.filelist[index]
        //console.log(preview)
        //return
        // See if we still have the files object opened - If now we need to get the image fromt he server
        try {
            preview = URL.createObjectURL(this.state.preview)

        }catch(err) {
            var file = this.state.filelist[index].filename.replaceAll(" ","_")
            var filepath = pdf_config.public_url + '/' + this.props.flg_id + '/images/' 
            preview = filepath + file
            console.log(preview)
            //preview = img
        }
        console_log(this.state.filelist[index])
        this.setState({image_preview: true, preview: preview})
    }
    closeImagePreview = () =>{this.setState({image_preview: false, preview: ''})}

    // Move the order of the filelist up or down.
    moveFileList = (index,direction) => {
        var fl = this.state.filelist
        if(index + direction < 0 || index+direction > fl.length) return;
        let swap = JSON.parse(JSON.stringify(fl[index+direction]))
        fl[index+direction] = JSON.parse(JSON.stringify(fl[index]))
        fl[index] = swap
        this.setState({filelist: fl})
    }
    render() {
        const { classes } = this.props;
        const files = this.state.filelist
        //console_log(files)

        if(this.state.delete_file)
            return (
                <AlertDialog
                    title = 'Confirm File Removal'
                    content={this.state.delete_file_msg}
                    onClose={this.delOnClose}
                    open={this.state.delete_file}
                    showopen={true}
                    showclose={true}
                    okPrompt="Yes" 
                    cancelPrompt="No"             
                /> 

            )

        return(
            <> 
            <Backdrop className={classes.backdrop} open={this.state.show_progress} >
                <Typography variant="caption" component="div" color="textSecondary">Files Uploading...</Typography>
                <CircularProgressWithLabel value={this.state.progress} color="secondary" size={150}/>
            </Backdrop>

            <div className={classes.formcontrol} >
                <label>Enter File Description&nbsp;&nbsp; </label>
                <input type="text" id="description" value={this.state.description} onChange={this.updateDescription}  />
                &nbsp;&nbsp;<label>Upload Your File&nbsp;&nbsp;</label>
                <input type="file" multiple onChange={this.onChangeHandler}/>
            </div> 
            <Collapse in={this.state.show_alert}> 
                <Alert
                    variant='outlined'
                    style={{width: '800px', alignItems: 'center', textAlign: 'top', marginTop: '10px'}} 
                    severity={this.state.alert_severity}          
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                this.setState({show_alert: false})
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton > 
                    } 
                >
                    {this.state.alert_text}
                </Alert>
            </Collapse> 
            {files.length >0 && 

            <TableContainer component={Paper} className={classes.tablecontainer}>
                <Table stickyHeader size="small" aria-label="a dense table" >
                    <TableHead size="small" >
                        <TableRow  size="small">
                            <TableCell size="small"  className={classes.header} >Preview</TableCell>
                            <TableCell size="small"  className={classes.header} >File</TableCell>
                            <TableCell size="small" className={classes.header} >Description</TableCell>
                            <TableCell size="small"  className={classes.header} >Delete</TableCell>
                            <TableCell size="small"  className={classes.header} >Order</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody size="medium" >
                    {files.map((item,index,max = files) => { 
                        return (
                        <TableRow key={index} size="small"  className={classes.text30} >
                            <TableCell size="small"  className={classes.text30} >
                                <IconButton
                                    aria-label="close" color="inherit"  size="small"
                                    onClick={() => {this.PreViewImage(index) }}
                                ><VisibilityOutlinedIcon fontSize="inherit" /></IconButton >  
                            </TableCell>                            
                            <TableCell size="small"  className={classes.text30} >{item.filename}</TableCell>
                            <TableCell size="small"  className={classes.text30} ><input type='text' value={item.description} onChange={event => this.updateDesc(event,index)} /> </TableCell>
                            <TableCell size="small"  className={classes.text30} >
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {this.DeleteFileFromList(index) }}
                                >
                                    <DeleteForeverOutlinedIcon fontSize="inherit" />
                                </IconButton >
                            </TableCell>
                            <TableCell size="small"  className={classes.text30} >
                                {index>0 &&
                                <Icon onClick={() => {this.moveFileList(index,-1) }} style={{ color: green[500], fontSize: '20px' }}>arrow_drop_up</Icon> }
                                {index+1 < max.length &&
                                <Icon onClick={() => {this.moveFileList(index,1) }} style={{ color: green[500], fontSize: '20px' }}>arrow_drop_down</Icon>}
                            </TableCell>

                            
                        </TableRow>
                        )})
                    }
                    <TableRow >
                        <TableCell colSpan={4} >
                        <ColorButton onClick={this.onClickHandler}>Upload Files</ColorButton>&nbsp;
                        <ColorButton onClick={this.DeleteFileList}>Clear File List</ColorButton>
                        {this.state.uploading && 
                        <Typography variant="caption" component="div" color="textSecondary">
                            File Upload Complete.
                        </Typography>}
                        <Typography variant="caption" component="div" color="textSecondary">{this.state.upload_error}</Typography>
                        </TableCell>
                    </TableRow>
                    </TableBody>
                </Table>
                </TableContainer>
            }
            {this.state.image_preview &&
           <Dialog
           open={this.state.image_preview}
           onClose={this.closeImagePreview }

           maxWidth="md"
           fullWidth={true} >
           <DialogTitle >Image Preview</DialogTitle>
           <DialogContent  >
                <img width="800px" src={this.state.preview} />
            </DialogContent>
           <DialogActions>
            <Button onClick={this.closeImagePreview} color="primary">Close</Button> 
           </DialogActions>
       </Dialog>           
        }
            </>
        )
    }
}
const styles = theme => ({
    document: {
      position: 'absolute',
      border: '1px solid #ff3099',
    },
    backdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 2000,
        width: '100%',
        height: '100%'
    },
    tablecontainer: {
        width: '810px',
        textAlign: 'center'
    },
    buttonspace: {
      marginRight: '10px'
    },
    formcontrol : {
        width: '800px',
        textAlign: 'left',
        border: '1px solid darkblue',
        paddingLeft: '5px',
        paddingRight: '5px',
        paddingTop: '20px',
        paddingBottom: '20px' 
    },
    text30: {
        fontSize: 14,
        paddingTop: 2,
        paddingBottom: 2,
        textAlign: 'left'

    },


})

export default withStyles(styles)(PictureUploads)
